import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AlertService } from '../alert.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { RegularExpressionConstant } from '../utils/regular-expression.constant';
import { PasswordValidator } from '../validators/password.validator';
import {Router, ActivatedRoute, NavigationExtras} from '@angular/router';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})


export class ResetPasswordPage implements OnInit {
	navigationExtras: any;
	matching_passwords_group: FormGroup;
	resetPasswordForm: FormGroup;
	isTokenValid = true;
  constructor(private route: ActivatedRoute,
  			  private router: Router,
  	 		  public authService: AuthService,
  	 		  private alertService: AlertService,
  			  public formBuilder: FormBuilder,) { 



  	this.matching_passwords_group = new FormGroup({
	password: new FormControl('', Validators.compose([
	 	Validators.required,
	 	Validators.pattern(RegularExpressionConstant.PASSWORD)
	])),
	password2: new FormControl('', Validators.required)
	}, (formGroup: FormGroup) => {
		 return PasswordValidator.areEqual(formGroup);
	});

	this.resetPasswordForm = this.formBuilder.group({
		id: ['', [Validators.required, Validators.minLength(1)]],
    	token: ['', [Validators.required, Validators.minLength(2)]],
		matching_passwords: this.matching_passwords_group,
	});

  }

  submitForm() {
  	let resetFormData: any = {};
  	resetFormData.id = this.resetPasswordForm.value.id;
  	resetFormData.password = this.resetPasswordForm.value.matching_passwords.password;
  	resetFormData.password2 = this.resetPasswordForm.value.matching_passwords.password2;
  	resetFormData.token = this.resetPasswordForm.value.token;
  	this.authService.resetPassword(resetFormData);
  }

  ngOnInit() {
	  this.route.queryParams.subscribe(params => {
	  if (params) {
	  	let paramsString = JSON.stringify(params);
	    let queryParams = JSON.parse(paramsString);
	    console.log(queryParams.id, queryParams.token)
	    if(queryParams.id != undefined && queryParams.token != undefined) {
      		this.resetPasswordForm.patchValue({
        		id : queryParams.id,
        		token: queryParams.token
      		})
			this.authService.checkTokenExist({token: queryParams.token}).subscribe(data => {
				this.isTokenValid = data['result'];
			});
    	} else {
    		this.alertService.presentToast('Invalid Reset Password Link');
    	}
	  }
	});
  }
}
